import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import BookingModal from '../components/BookingModal'
import ExperiencesCarousel from '../components/ExperiencesCarousel'
import FontAwesomeIcon from '../components/FontAwesomeIcon'

export default function SafariExperiences() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedExperience, setSelectedExperience] = useState('')
  const [experiences, setExperiences] = useState([])
  const [loading, setLoading] = useState(true)

  const handleBooking = (experience) => {
    setSelectedExperience(experience)
    setIsModalOpen(true)
  }

  // Hardcoded experiences as fallback
  const hardcodedExperiences = [
    // Multi-Day Safari Packages
    {
      slug: '17-days-ultimate-safari',
      title: '17 Days Ultimate Uganda Safari',
      icon: 'fa-globe',
      tagline: 'The Complete Uganda Experience',
      description: 'The definitive Uganda adventure covering all major national parks, primates, Big Five wildlife, culture, and adventure activities. From Murchison Falls to Bwindi gorillas, Kibale chimps to Queen Elizabeth\'s tree-climbing lions—experience everything Uganda offers in one unforgettable journey.',
      image: '/images/packages/17-days-safari.jpg',
      duration: '17 Days',
      difficulty: 'Moderate',
      price: 'Contact for pricing',
      rating: '4.9',
      reviews: 156,
      category: 'Multi-Day Safari',
      type: 'package',
      route: '/packages/17-days-ultimate-safari'
    },
    {
      slug: '12-days-wildlife-safari',
      title: '12 Days Uganda Wildlife Safari Tour',
      icon: 'fa-elephant',
      tagline: 'Perfect Balance of Primates & Wildlife',
      description: 'Experience the best of Uganda across five magnificent national parks. Track mountain gorillas in Bwindi, chimpanzees in Kibale, enjoy classic game drives in Murchison Falls and Queen Elizabeth, and wind down at Lake Mburo. The perfect 12-day adventure balancing primates and Big Five wildlife.',
      image: '/images/packages/12-days-safari.jpg',
      duration: '12 Days',
      difficulty: 'Moderate',
      price: 'From $3,800 per person',
      rating: '4.9',
      reviews: 203,
      category: 'Multi-Day Safari',
      type: 'package',
      route: '/packages/12-days-wildlife-safari'
    },
    {
      slug: '10-days-birding-safari',
      title: '10 Days Uganda Birding Safari',
      icon: 'fa-dove',
      tagline: '24 Albertine Rift Endemics Await',
      description: 'Uganda hosts over 1,060 bird species—more than half of Africa\'s total bird diversity. This specialized safari targets the 24 Albertine Rift endemics found in Uganda, plus hundreds of other spectacular species across diverse habitats from Mabamba Swamp to Bwindi\'s montane forests.',
      image: '/images/packages/10-days-birding.jpg',
      duration: '10 Days',
      difficulty: 'Moderate',
      price: 'Contact for pricing',
      rating: '4.9',
      reviews: 87,
      category: 'Multi-Day Safari',
      type: 'package',
      route: '/packages/10-days-birding-safari'
    },
    {
      slug: '8-days-highlights-safari',
      title: '8 Days Uganda Safari Highlights',
      icon: 'fa-star',
      tagline: 'Uganda\'s Greatest Hits',
      description: 'The perfect week-plus adventure covering four spectacular national parks: Murchison Falls, Kibale Forest, Queen Elizabeth, and Bwindi Impenetrable. Track gorillas and chimps, witness the Nile\'s power, spot tree-climbing lions, and cruise the Kazinga Channel—all in eight incredible days.',
      image: '/images/packages/8-days-highlights.jpg',
      duration: '8 Days',
      difficulty: 'Moderate',
      price: 'From $2,806 per person',
      rating: '4.8',
      reviews: 178,
      category: 'Multi-Day Safari',
      type: 'package',
      route: '/packages/8-days-highlights-safari'
    },
    {
      slug: '7-days-gorilla-chimp-safari',
      title: '7 Days Gorilla & Chimpanzee Safari',
      icon: 'fa-paw',
      tagline: 'Ultimate Primate Experience',
      description: 'Focused primate adventure combining the best of Uganda\'s ape encounters. Trek with mountain gorillas in Bwindi, track chimpanzees in Kibale Forest, and enjoy wildlife viewing in Queen Elizabeth National Park. A week dedicated to our closest living relatives in their natural habitats.',
      image: '/images/packages/7-days-gorilla-chimp.jpg',
      duration: '7 Days',
      difficulty: 'Moderate',
      price: 'Contact for pricing',
      rating: '4.9',
      reviews: 145,
      category: 'Multi-Day Safari',
      type: 'package',
      route: '/packages/7-days-gorilla-chimp-safari'
    },
    {
      slug: '5-days-gorillas-lions',
      title: '5 Day Gorillas and Lions Tour',
      icon: 'fa-lion',
      tagline: 'Maximum Impact, Minimum Time',
      description: 'Short on time but not willing to compromise? This five-day safari delivers Uganda\'s two most iconic sightings: tree-climbing lions in Ishasha and mountain gorillas in Bwindi. Perfect for travelers with limited vacation days but unlimited sense of adventure.',
      image: '/images/packages/5-days-gorillas-lions.jpg',
      duration: '5 Days',
      difficulty: 'Moderate',
      price: 'From $2,100 per person',
      rating: '4.8',
      reviews: 112,
      category: 'Multi-Day Safari',
      type: 'package',
      route: '/packages/5-days-gorillas-lions'
    },
    {
      slug: '3-days-kibale-chimp-cultural',
      title: '3 Days Chimpanzee & Cultural Safari - Kibale',
      icon: 'fa-users',
      tagline: 'Primates, Birds & Culture',
      description: 'Perfect weekend escape combining chimpanzee tracking in Kibale Forest, birdwatching in Bigodi Wetland Sanctuary, and authentic cultural village experiences. Discover why Kibale is called the Primate Capital of the World while connecting with local communities.',
      image: '/images/packages/3-days-kibale-cultural.jpg',
      duration: '3 Days',
      difficulty: 'Easy',
      price: 'Contact for pricing',
      rating: '4.7',
      reviews: 98,
      category: 'Multi-Day Safari',
      type: 'package',
      route: '/packages/3-days-kibale-chimp-cultural'
    },
    {
      slug: '3-days-murchison-chimp',
      title: '4 Days Murchison Falls Safari & Chimpanzee Tracking',
      icon: 'fa-water',
      tagline: 'Falls, Wildlife & Primates',
      description: 'Weekend adventure combining the explosive power of Murchison Falls, classic savannah game drives, boat cruises on the Nile, and chimpanzee tracking in Budongo Forest. Experience Uganda\'s largest national park and its incredible diversity in just three days.',
      image: '/images/packages/4-days-murchison-chimp.jpg',
      duration: '4 Days',
      difficulty: 'Moderate',
      price: 'Contact for pricing',
      rating: '4.8',
      reviews: 134,
      category: 'Multi-Day Safari',
      type: 'package',
      route: '/packages/3-days-murchison-chimp'
    },
    // Single-Park 3-Day Experiences
    {
      slug: 'queen-elizabeth-safari',
      title: '3 Days Safari Experience to Queen Elizabeth National Park',
      icon: 'fa-paw',
      tagline: 'Tree-Climbing Lions & Kazinga Channel',
      description: 'You\'ll find yourself in Uganda\'s most welcoming safari destination, where lions have learned to climb trees in the Ishasha sector - it\'s quite something to see these big cats lounging in the branches like oversized house cats. The Kazinga Channel feels like nature\'s own theater, with hippos grunting their morning greetings, elephants coming down for a drink, and more types of birds than you ever knew existed. It\'s the kind of place where every game drive and boat trip brings that genuine excitement of not knowing what you\'ll see next, but knowing it will be special.',
      image: '/images/packages/3-days-queen-elizabeth.jpg',
      duration: '3 Days',
      difficulty: 'Easy',
      price: '$450 per person',
      rating: '4.8',
      reviews: 189,
      category: 'Wildlife Safari',
      type: 'experience'
    },
    {
      slug: 'kidepo-valley-safari',
      title: '4 Days Safari Experience to Kidepo Valley National Park',
      icon: 'fa-paw',
      tagline: 'Uganda\'s Remote Wilderness Paradise',
      description: 'You\'ll drive for hours through changing landscapes until suddenly you\'re in a place that feels like the Africa of storybooks - vast plains stretching out to mountains that touch the sky. Here, in Uganda\'s most remote park, you might spot a cheetah scanning the horizon from a rocky outcrop, or watch ostriches striding across the grasslands like they\'ve been doing it forever. The Karamojong people welcome you with a warmth that makes you feel like you\'ve come home, sharing stories around evening fires that connect you to generations of living in harmony with this wild land.',
      image: '/images/packages/4-days-kidepo.jpg',
      duration: '4 Days',
      difficulty: 'Moderate',
      price: 'Contact for pricing',
      rating: '4.8',
      reviews: 105,
      category: 'Wildlife Safari',
      type: 'experience'
    },
    {
      slug: 'lake-mburo-safari',
      title: '3 Days Safari Experience to Lake Mburo National Park',
      icon: 'fa-paw',
      tagline: 'Walking Safaris & Unique Wildlife',
      description: 'This is the kind of place that reminds you why you came to Africa in the first place - intimate, welcoming, and full of those quiet moments that become treasured memories. You can walk right up to zebras that graze as if you\'re not even there, take a boat ride where hippos surface nearby with their curious eyes, or even ride horses through the savanna like you\'re part of an old adventure story. It\'s smaller than other parks, which just means you get to know it better, see the personalities of the animals, and feel that genuine connection to a place that welcomes you like a friend.',
      image: '/images/packages/3-days-lake-mburo.jpg',
      duration: '3 Days',
      difficulty: 'Easy',
      price: '$350 per person',
      rating: '4.6',
      reviews: 156,
      category: 'Wildlife Safari',
      type: 'experience'
    },
    {
      slug: 'rwenzori-mountains-trek',
      title: '8 Days Trekking Experience to Rwenzori Mountains Margherita Peak',
      icon: 'fa-mountain',
      tagline: 'Africa\'s Mystical Mountains of the Moon',
      description: 'You\'ll feel like you\'ve stepped into another world when you enter these mountains - where giant lobelia plants tower over you like strange trees from a fairy tale, and moss drapes everything in soft green mystery. The air grows colder as you climb toward Margherita Peak, Africa\'s third-highest mountain, until you\'re walking through landscapes that don\'t seem like they belong on this continent. It\'s challenging, yes, but that moment when you stand at 5,109 meters looking out over valleys you\'ve crossed and peaks you\'ve conquered stays with you forever. These are the Mountains of the Moon, and they\'ll change how you see the world.',
      image: '/images/packages/8-days-rwenzori.jpg',
      duration: '7-9 Days',
      difficulty: 'Challenging',
      price: 'Contact for pricing',
      rating: '4.9',
      reviews: 67,
      category: 'Adventure & Hiking',
      type: 'experience'
    },
    {
      slug: 'bwindi-gorilla-trekking',
      title: '3 Days Safari Experience to Bwindi Impenetrable National Park',
      icon: 'fa-paw',
      tagline: 'Encounter Mountain Gorillas in Ancient Rainforest',
      description: 'You\'ll walk into a forest that feels like it\'s been waiting for you, where every step brings you closer to one of life\'s most moving experiences - sitting quietly while a family of mountain gorillas goes about their day around you. These are our closest relatives, looking back at you with eyes that seem to understand something profound. Bwindi isn\'t just beautiful because of its ancient trees and misty hills; it\'s special because of those moments when a young gorilla plays nearby, or a silverback watches over his family, and you realize you\'re not just visiting - you\'re being welcomed into something timeless and precious.',
      image: '/images/packages/3-days-bwindi.jpg',
      duration: '3 Days',
      difficulty: 'Moderate',
      price: '$750 per person',
      rating: '4.9',
      reviews: 234,
      category: 'Wildlife Safari',
      type: 'experience'
    },
    {
      slug: 'kibale-chimp-tracking',
      title: '3 Days Safari Experience to Kibale National Park',
      icon: 'fa-paw',
      tagline: 'Primate Capital of the World',
      description: 'You\'ll walk into Kibale Forest and suddenly realize you\'re in a place where primates rule - chimpanzees calling to each other through the canopy, monkeys swinging from branch to branch like they\'re putting on a show just for you. This is where you sit quietly and watch a chimpanzee family interact, groom each other, and play, and you understand why scientists say we\'re so closely related. The forest envelops you in its cool, green embrace, and you leave knowing you\'ve witnessed something both wonderfully wild and deeply familiar. It\'s not just about seeing chimpanzees; it\'s about feeling connected to the very beginning of what makes us human.',
      image: '/images/chimpanzee-kibale.jpg',
      duration: '3 Days',
      difficulty: 'Moderate',
      price: '$200 per person',
      rating: '4.8',
      reviews: 178,
      category: 'Wildlife Safari',
      type: 'experience'
    }
  ]

  // Fetch packages from CMS
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        setLoading(true)
        const response = await fetch('http://localhost:3001/api/packages?limit=100')

        if (!response.ok) {
          throw new Error('Failed to fetch packages')
        }

        const data = await response.json()

        // Transform CMS packages to match component format
        const transformedPackages = data.docs
          .filter(pkg => pkg.status === 'published')
          .map(pkg => ({
            slug: pkg.slug,
            title: pkg.title,
            icon: pkg.icon || 'fa-globe',
            tagline: pkg.tagline || '',
            description: pkg.overview || pkg.description || '',
            image: pkg.featuredImage?.sizes?.card?.url || pkg.featuredImage?.url || 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800',
            duration: pkg.duration || 'Contact us',
            difficulty: pkg.difficulty || 'Moderate',
            price: pkg.price ? `From $${pkg.price} per person` : 'Contact for pricing',
            rating: pkg.rating || '4.8',
            reviews: pkg.reviewCount || 0,
            category: pkg.category || 'Multi-Day Safari',
            type: 'package',
            route: `/packages/${pkg.slug}`,
            source: 'cms'
          }))

        // Combine CMS packages with hardcoded experiences
        const combinedExperiences = [
          ...hardcodedExperiences.map(e => ({ ...e, source: 'hardcoded' })),
          ...transformedPackages
        ]

        setExperiences(combinedExperiences)
      } catch (err) {
        console.error('Error fetching packages:', err)
        // Fallback to hardcoded experiences if CMS fails
        setExperiences(hardcodedExperiences)
      } finally {
        setLoading(false)
      }
    }

    fetchPackages()
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-safari-green"></div>
          <p className="text-gray-600 mt-4">Loading safari experiences...</p>
        </div>
      </div>
    )
  }

  return (
    <div>
      {/* Hero Section with Experiences Carousel */}
      <div className="relative" style={{ borderRadius: '0px' }}>
        <ExperiencesCarousel />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="container mx-auto px-4 text-center text-white z-20">
            <h1 className="text-3xl md:text-5xl font-bold mb-3 font-heading drop-shadow-lg">
              Adventure Experiences
            </h1>
            <p className="text-lg md:text-xl max-w-3xl mx-auto drop-shadow-lg">
              From wildlife safaris and gorilla encounters to mountain treks and cultural immersions - discover the adventures that make Uganda unforgettable
            </p>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl text-center">
          <p className="text-lg text-gray-700 leading-relaxed">
            We believe that the best adventure experiences come from genuine connections - with the land, the wildlife, and the people who call these places home.
            That's why we've put together journeys that let you step beyond the ordinary tourist path and into something real and memorable.
            Whether you're sitting quietly with a gorilla family, conquering mountain peaks, or feeling the ground shake beneath Murchison Falls, these are the moments that inspire and transform you.
          </p>
        </div>
      </section>

      {/* Experiences */}
      <section className="py-20 bg-safari-light">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {experiences.map((experience, index) => {
              return (
                <div key={index} className="card">
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={experience.image}
                      alt={experience.title}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-4 right-4 bg-white rounded-full p-4 text-4xl shadow-lg">
                      <FontAwesomeIcon icon={experience.icon} className="w-12 h-12 text-safari-green" />
                    </div>
                  </div>

                  <div className="p-6">
                    <div className="mb-2">
                      <h2 className="text-xl font-bold text-safari-green">
                        {experience.title}
                      </h2>
                    </div>
                    <p className="text-sm text-safari-gold italic mb-4">{experience.tagline}</p>

                    <p className="text-base text-gray-700 mb-6 leading-relaxed line-clamp-3">
                      {experience.description}
                    </p>

                    <div className="grid grid-cols-3 gap-4 mb-6 pb-6 border-b">
                      <div>
                        <p className="text-xs font-semibold text-gray-600 mb-1">Duration</p>
                        <p className="text-sm text-gray-800">{experience.duration}</p>
                      </div>
                      <div>
                        <p className="text-xs font-semibold text-gray-600 mb-1">Difficulty</p>
                        <p className="text-sm text-gray-800">{experience.difficulty}</p>
                      </div>
                      <div>
                        <p className="text-xs font-semibold text-gray-600 mb-1">Price</p>
                        <p className="text-sm text-gray-800 font-bold">{experience.price}</p>
                      </div>
                    </div>

                    <Link
                      to={experience.type === 'package' ? experience.route : `/experiences/${experience.slug}`}
                      className="btn-primary w-full block text-center"
                    >
                      View Full Details
                    </Link>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* What to Expect */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12 text-safari-green">What to Expect on Your Adventure</h2>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="card group flex flex-col h-full">
              <div className="relative h-32 overflow-hidden flex-shrink-0 bg-gradient-to-br from-safari-gold to-safari-green flex items-center justify-center">
                <div className="text-5xl"><FontAwesomeIcon icon="fa-sun" className="w-16 h-16 text-white" /></div>
              </div>
              <div className="p-6 flex flex-col flex-grow text-center">
                <h3 className="text-2xl font-bold mb-3 text-safari-green">Early Starts</h3>
                <p className="text-gray-700 text-sm flex-grow">
                  The animals are early risers, so you should be too! Those pre-dawn starts mean you'll be there when the lions are most active and the light is perfect for photos.
                </p>
              </div>
            </div>

            <div className="card group flex flex-col h-full">
              <div className="relative h-32 overflow-hidden flex-shrink-0 bg-gradient-to-br from-safari-green to-safari-gold flex items-center justify-center">
                <div className="text-5xl"><FontAwesomeIcon icon="fa-camera" className="w-16 h-16 text-white" /></div>
              </div>
              <div className="p-6 flex flex-col flex-grow text-center">
                <h3 className="text-2xl font-bold mb-3 text-safari-green">Photo Opportunities</h3>
                <p className="text-gray-700 text-sm flex-grow">
                  Oh, and bring extra memory cards! You'll want to capture every moment - from a gorilla's curious stare to an elephant's knowing wink.
                </p>
              </div>
            </div>

            <div className="card group flex flex-col h-full">
              <div className="relative h-32 overflow-hidden flex-shrink-0 bg-gradient-to-br from-safari-gold to-safari-green flex items-center justify-center">
                <div className="text-5xl"><FontAwesomeIcon icon="fa-person-hiking" className="w-16 h-16 text-white" /></div>
              </div>
              <div className="p-6 flex flex-col flex-grow text-center">
                <h3 className="text-2xl font-bold mb-3 text-safari-green">Physical Activity</h3>
                <p className="text-gray-700 text-sm flex-grow">
                  Some experiences involve trekking. Maintain a moderate fitness level and bring appropriate gear.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 md:py-20 bg-safari-light">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center" style={{ border: '1px solid #24684f' }}>
            <h2 className="text-3xl md:text-4xl font-bold text-safari-green mb-6">
              Combine Multiple Experiences
            </h2>
            <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
              Combine multiple experiences to create your ideal Uganda adventure. Our team will design a custom itinerary that matches your interests, timeline, and travel style.
            </p>
            <button onClick={() => handleBooking('Custom Package')} className="btn-primary text-lg">
              Design Your Adventure
            </button>
          </div>
        </div>
      </section>

      <BookingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        experience={selectedExperience}
      />
    </div>
  )
}
